import { render } from "./ZhuhaiInstitution.vue?vue&type=template&id=c1d0e690&scoped=true"
import script from "./ZhuhaiInstitution.vue?vue&type=script&lang=js"
export * from "./ZhuhaiInstitution.vue?vue&type=script&lang=js"

import "./ZhuhaiInstitution.vue?vue&type=style&index=0&id=c1d0e690&lang=less&scoped=true"

import exportComponent from "C:\\IdeaProjects\\frontEnd\\gdstiweb\\node_modules\\.pnpm\\registry.npmmirror.com+vue-loader@16.8.3_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1d0e690"]])

export default __exports__